export default __webpack_public_path__ + "media/src/assets/images/DOT_hazmat_class_1.3-006ff9a250c564fa69715d2d036ba899.svg";